<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { createEventDispatcher, onMount } from 'svelte'
    import { Comission, ComissionTypeEnum } from '../../modules/eventsApi/comissions/comission'
    import dayjs from 'dayjs'
    import { User } from '../../modules/usersApi/users/user'
    import type { CreateComissionDto } from '../../modules/eventsApi/comissions/dto/create-comission.dto'
    import type { UpdateComissionDto } from '../../modules/eventsApi/comissions/dto/update-comission.dto'
    import Zframe from '../_common/z/zframe.svelte'
    const dispatch = createEventDispatcher()

    export let comissionId: string = null
    export let creditDebit: ComissionTypeEnum

    let show = false
    let entity: Comission = new Comission()
    let createdAt = dayjs(new Date()).format('YYYY-MM-DD')
    let user: User = null

    onMount(async () => {
        if (comissionId) {
            await loadEntity(comissionId)
        } else {
            newEntity()
        }
    })

    async function loadEntity(id: string) {
        try {
            show = true
            entity = new Comission()
            entity = await window.api.events.comissions.getOne(id)
            createdAt = dayjs(entity.paidAt).format('YYYY-MM-DD')
            user = new User()
            user.userId = entity.userId
            user = user
            console.log('comission', entity)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        if (!creditDebit) {
            throw new Error('Tipo (credito/debito) não informado')
        }
        entity = new Comission()
        entity.createdAt = new Date(createdAt)
        entity.type = creditDebit
    }

    async function saveEntity() {
        if (entity.comissionId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function createEntity() {
        try {
            show = true
            entity.paidAt = new Date(createdAt)
            entity.paidAt.setMinutes(entity.paidAt.getMinutes() + entity.paidAt.getTimezoneOffset())
            const dto: CreateComissionDto = {
                description: entity.description,
                type: entity.type,
                userId: user?.userId,
                value: entity.value,
                paidAt: entity.paidAt,
            }
            if (!validateDto(dto)) return false
            entity = await window.api.events.comissions.create(dto)
            dispatch('change')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            entity.paidAt = new Date(createdAt)
            entity.paidAt.setMinutes(entity.paidAt.getMinutes() + entity.paidAt.getTimezoneOffset())
            const dto: UpdateComissionDto = {
                description: entity.description,
                type: entity.type,
                userId: user?.userId,
                value: entity.value,
                paidAt: entity.paidAt,
            }
            if (!validateDto(dto)) return false
            entity = await window.api.events.comissions.update(entity.comissionId, dto)
            dispatch('change')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function validateDto(dto) {
        if (!dto.userId) {
            window.error('Selecione o usuário')
            return false
        }
        if (!dto.value) {
            window.error('Informe o valor')
            return false
        }
        if (!dto.description) {
            window.error('Informe a descrição do lançamento')
            return false
        }
        return true
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.events.comissions.remove(entity.comissionId)
            dispatch('change')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }
</script>

{#if !show}
    <div class="root purchase-show">
        <div class="container">
            <div class="row bar-top">
                <div class="col d-flex">
                    {#if entity.comissionId}
                        <button on:click={removeEntity} class="btn btn-warning">Excluir</button>
                    {/if}
                    <div class="spacer" />
                    <button on:click={saveEntity} class="btn btn-secondary">Salvar</button>
                </div>
            </div>
            <Zframe class="my-3" title="Lançamento" headline="">
                <div class="grid-form">
                    <div class="row">
                        <div class="col-md-6">
                            <ZentitySelect fonte="usuario" label="Usuário" bind:value={user} />
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <label for="" class="input-group-text">Vencimento</label>
                                <input type="date" bind:value={createdAt} class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Descrição</label>
                                <input type="text" bind:value={entity.description} class="form-control" />
                            </div>
                        </div>
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Valor</label>
                                <input type="number" bind:value={entity.value} class="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
            </Zframe>
        </div>
    </div>
{/if}
